<!-- time-counter.component.html -->
<div>
    <ng-container *ngIf="customTemplate;else defaultContent" [ngTemplateOutlet]="customTemplate" [ngTemplateOutletContext]="{ $implicit: time }">
    </ng-container>

    <ng-template #defaultContent>
        <p>Time Elapsed: {{ time | date:'hh:mm:ss'}} seconds</p>
    </ng-template>
</div>